/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { ComputeMetricDto } from '../models';
import { CreateEmptyDashboardDto } from '../models';
import { DashboardContent } from '../models';
import { DashboardTable } from '../models';
import { DataSourceDto } from '../models';
import { DataSourceValidationResponseDto } from '../models';
import { DatabaseRelationDto } from '../models';
import { MetricResultDto } from '../models';
import { QueryResultDto } from '../models';
/**
 * DashboardsApi - axios parameter creator
 * @export
 */
export const DashboardsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Compute the metric result
     * @param {ComputeMetricDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerComputeMetric: async (
      body: ComputeMetricDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling dashboardsControllerComputeMetric.'
        );
      }
      const localVarPath = `/dashboards/computeMetric`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new dashboard
     * @param {CreateEmptyDashboardDto} body Dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerCreate: async (
      body: CreateEmptyDashboardDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling dashboardsControllerCreate.'
        );
      }
      const localVarPath = `/dashboards`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a dashboard by ID
     * @param {string} id The ID of the dashboard to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerDelete: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling dashboardsControllerDelete.'
        );
      }
      const localVarPath = `/dashboards/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve all dashboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerFindAllAvailable: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/dashboards`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve a dashboard by its ID
     * @param {string} id Unique dashboard identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerFindOne: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling dashboardsControllerFindOne.'
        );
      }
      const localVarPath = `/dashboards/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the list of base tables relations the user can use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerGetAllBaseTablesRelations: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/dashboards/baseTablesRelations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Check whether a data source is valid
     * @param {DataSourceDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerIsDataSourceValid: async (
      body: DataSourceDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling dashboardsControllerIsDataSourceValid.'
        );
      }
      const localVarPath = `/dashboards/isDataSourceValid`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve the Data corresponding to a Data Source
     * @param {DataSourceDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerRetrieveDataFromDataSource: async (
      body: DataSourceDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling dashboardsControllerRetrieveDataFromDataSource.'
        );
      }
      const localVarPath = `/dashboards/dataFromDataSource`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create or update a dashboard
     * @param {DashboardContent} body Dashboard content to create or update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardsControllerSaveDashboard: async (
      body: DashboardContent,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling dashboardsControllerSaveDashboard.'
        );
      }
      const localVarPath = `/dashboards/saveDashboard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DashboardsApi - functional programming interface
 * @export
 */
export const DashboardsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Compute the metric result
     * @param {ComputeMetricDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerComputeMetric(
      body: ComputeMetricDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<MetricResultDto>>
    > {
      const localVarAxiosArgs = await DashboardsApiAxiosParamCreator(
        configuration
      ).dashboardsControllerComputeMetric(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Create a new dashboard
     * @param {CreateEmptyDashboardDto} body Dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerCreate(
      body: CreateEmptyDashboardDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<DashboardTable>>
    > {
      const localVarAxiosArgs = await DashboardsApiAxiosParamCreator(
        configuration
      ).dashboardsControllerCreate(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Delete a dashboard by ID
     * @param {string} id The ID of the dashboard to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerDelete(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<DashboardTable>>
    > {
      const localVarAxiosArgs = await DashboardsApiAxiosParamCreator(
        configuration
      ).dashboardsControllerDelete(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieve all dashboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerFindAllAvailable(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<DashboardTable>>>
    > {
      const localVarAxiosArgs =
        await DashboardsApiAxiosParamCreator(
          configuration
        ).dashboardsControllerFindAllAvailable(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieve a dashboard by its ID
     * @param {string} id Unique dashboard identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerFindOne(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<DashboardContent>>
    > {
      const localVarAxiosArgs = await DashboardsApiAxiosParamCreator(
        configuration
      ).dashboardsControllerFindOne(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the list of base tables relations the user can use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerGetAllBaseTablesRelations(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<DatabaseRelationDto>>>
    > {
      const localVarAxiosArgs =
        await DashboardsApiAxiosParamCreator(
          configuration
        ).dashboardsControllerGetAllBaseTablesRelations(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Check whether a data source is valid
     * @param {DataSourceDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerIsDataSourceValid(
      body: DataSourceDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<DataSourceValidationResponseDto>>
    > {
      const localVarAxiosArgs = await DashboardsApiAxiosParamCreator(
        configuration
      ).dashboardsControllerIsDataSourceValid(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieve the Data corresponding to a Data Source
     * @param {DataSourceDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerRetrieveDataFromDataSource(
      body: DataSourceDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<QueryResultDto>>
    > {
      const localVarAxiosArgs = await DashboardsApiAxiosParamCreator(
        configuration
      ).dashboardsControllerRetrieveDataFromDataSource(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Create or update a dashboard
     * @param {DashboardContent} body Dashboard content to create or update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerSaveDashboard(
      body: DashboardContent,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await DashboardsApiAxiosParamCreator(
        configuration
      ).dashboardsControllerSaveDashboard(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * DashboardsApi - factory interface
 * @export
 */
export const DashboardsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Compute the metric result
     * @param {ComputeMetricDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerComputeMetric(
      body: ComputeMetricDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<MetricResultDto>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerComputeMetric(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new dashboard
     * @param {CreateEmptyDashboardDto} body Dashboard data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerCreate(
      body: CreateEmptyDashboardDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<DashboardTable>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerCreate(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a dashboard by ID
     * @param {string} id The ID of the dashboard to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerDelete(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<DashboardTable>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerDelete(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve all dashboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerFindAllAvailable(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<DashboardTable>>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerFindAllAvailable(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve a dashboard by its ID
     * @param {string} id Unique dashboard identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerFindOne(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<DashboardContent>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerFindOne(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the list of base tables relations the user can use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerGetAllBaseTablesRelations(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<DatabaseRelationDto>>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerGetAllBaseTablesRelations(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Check whether a data source is valid
     * @param {DataSourceDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerIsDataSourceValid(
      body: DataSourceDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<DataSourceValidationResponseDto>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerIsDataSourceValid(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve the Data corresponding to a Data Source
     * @param {DataSourceDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerRetrieveDataFromDataSource(
      body: DataSourceDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<QueryResultDto>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerRetrieveDataFromDataSource(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create or update a dashboard
     * @param {DashboardContent} body Dashboard content to create or update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardsControllerSaveDashboard(
      body: DashboardContent,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return DashboardsApiFp(configuration)
        .dashboardsControllerSaveDashboard(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DashboardsApi - object-oriented interface
 * @export
 * @class DashboardsApi
 * @extends {BaseAPI}
 */
export class DashboardsApi extends BaseAPI {
  /**
   *
   * @summary Compute the metric result
   * @param {ComputeMetricDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerComputeMetric(
    body: ComputeMetricDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MetricResultDto>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerComputeMetric(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Create a new dashboard
   * @param {CreateEmptyDashboardDto} body Dashboard data.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerCreate(
    body: CreateEmptyDashboardDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DashboardTable>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerCreate(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Delete a dashboard by ID
   * @param {string} id The ID of the dashboard to delete.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerDelete(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DashboardTable>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerDelete(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieve all dashboards
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerFindAllAvailable(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<DashboardTable>>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerFindAllAvailable(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieve a dashboard by its ID
   * @param {string} id Unique dashboard identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerFindOne(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DashboardContent>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerFindOne(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the list of base tables relations the user can use
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerGetAllBaseTablesRelations(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<DatabaseRelationDto>>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerGetAllBaseTablesRelations(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Check whether a data source is valid
   * @param {DataSourceDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerIsDataSourceValid(
    body: DataSourceDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<DataSourceValidationResponseDto>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerIsDataSourceValid(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieve the Data corresponding to a Data Source
   * @param {DataSourceDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerRetrieveDataFromDataSource(
    body: DataSourceDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<QueryResultDto>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerRetrieveDataFromDataSource(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Create or update a dashboard
   * @param {DashboardContent} body Dashboard content to create or update
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardsApi
   */
  public async dashboardsControllerSaveDashboard(
    body: DashboardContent,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return DashboardsApiFp(this.configuration)
      .dashboardsControllerSaveDashboard(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
